import { scenes } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

const tints = [
  "border-secondary-200 bg-secondary-100",
  "border-accent-200 bg-accent-100",
  "border-primary-200 bg-primary-100",
];

export default function Scenes() {
  return (
    <section id="scene" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="名场面 · 弹幕梗"
          title="这些梗，全网都在刷"
          desc="「御用拖」「战术性加班」「碗德」……这些从评论区长出来的热梗和名场面，全都出自网友的脑洞，今天你刷到第几个？"
        />

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {scenes.map((s, i) => (
            <article
              key={s.title}
              className={`flex flex-col rounded-2xl border p-5 transition-all hover:-translate-y-1 hover:rotate-0 ${
                i % 2 === 0 ? "-rotate-1" : "rotate-1"
              } ${tints[i % tints.length]}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-lg text-foreground-900 md:text-xl">{s.title}</span>
                <span
                  className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold text-background-50 ${
                    i % 2 === 0 ? "bg-accent-500" : "bg-primary-600"
                  }`}
                >
                  {s.hitText}
                </span>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{s.text}</p>
              <div className="mt-4 flex items-center justify-between border-t border-foreground-100 pt-3 text-xs">
                <span className="inline-flex items-center gap-1.5 text-foreground-600">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-50 text-[10px] text-primary-700">
                    {s.author.charAt(0)}
                  </span>
                  {s.author}
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-accent-600">
                  <i className="ri-fire-line"></i>
                  {s.likes.toLocaleString()} 热度
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}